import { j as r } from "./atoms-v218.js";
import { forwardRef as p } from "react";
import { Button as s } from "./atoms-v26.js";
import { Footer as x, FooterLeft as u, FooterRight as c } from "./atoms-v2784.js";
import { useBreakpoints as h } from "./atoms-v251.js";
const j = p(
  ({
    cancelButton: e,
    cancelText: o = "Cancel",
    confirmButton: t,
    confirmText: i = "Confirm",
    isDismissable: n = !0,
    onCancel: a,
    onConfirm: l
  }, m) => {
    const { current: d } = h();
    return /* @__PURE__ */ r.jsxs(x, { ref: m, children: [
      /* @__PURE__ */ r.jsx(u, { children: n ? /* @__PURE__ */ r.jsx(r.Fragment, { children: e || /* @__PURE__ */ r.jsx(s, { textOnly: !0, ariaLabel: o, onClick: a, variant: "ghost", children: o }) }) : null }),
      /* @__PURE__ */ r.jsx(c, { children: t || /* @__PURE__ */ r.jsx(
        s,
        {
          textOnly: !0,
          ariaLabel: i,
          display: "block",
          onClick: l,
          size: ["max", "maxPlus"].includes(d) ? "expressive" : "medium",
          children: i
        }
      ) })
    ] });
  }
);
j.displayName = "AnchoredDialog.Footer";
export {
  j as Footer
};
